import { render } from "./MainOfficer.vue?vue&type=template&id=161489b4&scoped=true"
import script from "./MainOfficer.vue?vue&type=script&lang=js"
export * from "./MainOfficer.vue?vue&type=script&lang=js"

import "./MainOfficer.vue?vue&type=style&index=0&id=161489b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161489b4"]])

export default __exports__